import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageMeta } from "../utils/pageMeta";

const usePageMeta = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const { description } = getPageMeta(pathname);
    const tag = document.head.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );

    if (tag) tag.setAttribute("content", description);
  }, [pathname]);
};

export default usePageMeta;
